

import { getLogger } from './logger'

export const _buildEngine = (source, vtLayer, refreshOnChange = true) => {

  if (!source.filterSet)
    source.filterSet = { mode: "NONE", values: {}, layer: null };

  const changed = () => {
    if (refreshOnChange) {
      getLogger()("Filter changed, refreshing layer", vtLayer.id);
      source.refresh();
    }
  }

  return {
    when: (field) => {

      if (source.filterSet.mode == "NONE")
        source.filterSet.mode = "OR"

      return {
        isAny: (values) => {
          source.filterSet.values[field] = { any: true, values: values };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isAll: (values) => {
          source.filterSet.values[field] = { all: true, values: values };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        contains: (value) => {
          source.filterSet.values[field] = { contains: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        containsAny: (values) => {
          source.filterSet.values[field] = { containsAny: true, values: values };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        containsAll: (values) => {
          source.filterSet.values[field] = { containsAll: true, values: values };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isExactly: (value) => {
          source.filterSet.values[field] = { exactly: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isGreaterThan: (value) => {
          source.filterSet.values[field] = { greater: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isLessThan: (value) => {
          source.filterSet.values[field] = { less: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isInRange: (greater, less) => {
          source.filterSet.values[field] = { range: true, values: { greater, less } };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isAfter: (value) => {
          source.filterSet.values[field] = { after: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isBefore: (value) => {
          source.filterSet.values[field] = { before: true, values: value };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        isBetween: (after, before) => {
          source.filterSet.values[field] = { between: true, values: { after, before } };
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        },
        clear: () => {
          delete source.filterSet.values[field];
          getLogger()(source.filterSet);
          changed();
          return _buildEngine(source, vtLayer);
        }
      }
    },
    clear: () => {
      source.filterSet.values = {};
      source.filterSet.mode = "NONE"
      changed();
      return _buildEngine(source, vtLayer);
    },
    andJoin: () => {
      source.filterSet.mode = "AND"
      getLogger()(source.filterSet);
      changed();
      return _buildEngine(source, vtLayer);
    },
    orJoin: () => {
      source.filterSet.mode = "OR"
      getLogger()(source.filterSet);
      changed();
      return _buildEngine(source, vtLayer);
    },
    appliesTo: (layer) => {
      source.filterSet.layer = layer;
      getLogger()(source.filterSet);
      changed();
      return _buildEngine(source, vtLayer);
    }
  }
};

const extractValue = (feature, field) => {
  // The field may have a dot notation for nested properties
  const keys = field.split('.');
  let value = feature.properties_;
  for (let key of keys) {
    if (value && typeof value === 'object' && key in value)
      value = value[key] || null;
    else
      value = null;
  }
  return value;
};

export const _checkFilter = (source, feature) => {
  getLogger()("Checking filters for", feature.getId(), "on source", source.id);
  if (source.filterSet) {
    let value = false;

    if (source.filterSet.mode == "AND")
      value = true;

    let keys = Object.keys(source.filterSet.values);
    let fields = Object.keys(feature.properties_);
    getLogger()("Filter keys", keys, "fields", fields);

    if (!keys.length)
      value = true;

    for (let field of keys) {
      getLogger()("Checking", field);
      let filterMatch = false;

      const fieldValue = extractValue(feature, field);
      getLogger()("Value", fieldValue);

      let filter = source.filterSet.values[field];
      let valueToTest = fieldValue || feature.properties_[field];

      if (filter.any) {
        if (Array.isArray(valueToTest)) {
          filterMatch = valueToTest.some(val => filter.values.includes(val));
        }
        else if (filter.values.includes(valueToTest)) {
          filterMatch = true;
        }
      }
      else if (filter.all) {
        filterMatch = true;
        for (let value of filter.values)
          filterMatch = filterMatch && valueToTest == value;
      }
      else if (filter.contains && (valueToTest + "").indexOf(filter.values) >= 0)
        filterMatch = true;
      else if (filter.containsAny) {
        filterMatch = false || filter.values.length == 0;
        for (let value of filter.values) {
          if ((valueToTest + "").indexOf(value) >= 0) {
            filterMatch = true;
            break;
          }
        }
      }
      else if (filter.containsAll) {
        filtermatch = true;
        for (let value of filter.values) {
          if (((valueToTest + "").indexOf(value) < 0)) {
            filterMatch = false;
            break;
          }
        }
      }
      else if (filter.exactly && valueToTest == filter.values) {
        filterMatch = true;
      }
      else if(filter.greater) {
        filterMatch = valueToTest > filter.values;
      }
      else if(filter.less) {
        filterMatch = valueToTest < filter.values;
      }
      else if(filter.range) {
        filterMatch = valueToTest > filter.values.greater &&
        valueToTest < filter.values.less;
      }
      else if(filter.after) {
        filterMatch = new Date(valueToTest) > new Date(filter.values);
      }
      else if(filter.before) {
        filterMatch = new Date(valueToTest) < new Date(filter.values);
      } else if(filter.between) {
        filterMatch = (new Date(valueToTest) > new Date(filter.values.after)) && 
          (new Date(valueToTest) < new Date(filter.values.before));
      }


      if (source.filterSet.mode == "AND")
        value = value && filterMatch;

      if (source.filterSet.mode == "OR")
        value = value || filterMatch;
    }

    getLogger()("Final value for feature", feature.getId(), "is", value);

    return value;
  }

  //When there is no filterSet, everything is shown
  return true;
}